<template>
    <div id="customerAccount">
        <el-form ref="searchForm" :inline="true" :model="searchForm" @submit.native.prevent>
            <el-form-item label="代理商名称：">
                <el-input v-model.trim="searchForm.name"  @keyup.enter.native="getAccountListPageHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="代理商账号：">
                <el-input v-model.trim="searchForm.sysUserAccountName" @keyup.enter.native="getAccountListPageHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="账号状态：">
                <el-select v-model.trim="searchForm.accountState" clearable>
                    <el-option value="1" label="启用"></el-option>
                    <el-option value="0" label="禁用"></el-option>
                </el-select>
            </el-form-item>   
            <el-form-item>
                <el-button type="primary" @click="getAccountListPageHandle" plain icon="el-icon-search">搜索</el-button>
            </el-form-item>
            <p style="color:red;margin-bottom: 20px;">{{agentRemark}}</p>
        </el-form>
        <el-table :data="tbpg.tableData" 
		border
		fit
		highlight-current-row
		style="width: 100%;"
		:header-cell-style="{background:'#f5f5f5'}"
		>
            <el-table-column prop="name" label="代理商名称 " align="center"></el-table-column>
            <el-table-column prop="pathNames" label="层级关系" align="center"></el-table-column>
            <el-table-column prop="sysUserAccountName" label="代理商账号" align="center"></el-table-column>
                 <el-table-column prop="lossOrder" label="丢单倍数"></el-table-column>
            <!-- <el-table-column prop="cashbackStateName" label="秒返状态"></el-table-column> -->
            <el-table-column prop="yongjingData" label="未提佣金" align="center"></el-table-column>
            <el-table-column prop="yuchongzhiData" label="剩余预存" align="center"></el-table-column>
            <el-table-column prop="accountStateName" label="账号状态" align="center"></el-table-column>
            <!-- <el-table-column prop="isCashbackName" label="允许秒返"></el-table-column> -->
            <el-table-column prop="createTime" label="新建时间" align="center"></el-table-column>
            <el-table-column label="操作" align="center" width="480" fixed="right">
                <template slot-scope="scope" >
                      <el-button type="text"  @click="authCount(scope.row)">认证次数-1</el-button>
                      <el-button type="text" @click="loginAccount(scope.row.sysUserAccountName)">登录账号</el-button>
                    <!-- <el-button type="text" size="small" @click="changeCashbackStateHandle(scope.row.id)">{{showbtnText(scope.row.isCashback)}}</el-button> -->
                    <!-- <el-button type="text" size="small" @click="showCollectionConfigVisible(scope.row.id)">收款配置</el-button> -->
                     <el-button type="text" size="small" @click="getImportFailRecordListHandle(scope.row.id, $event)">佣金记录</el-button>
                    <el-button type="text" @click="showChangeBalanceDialog(scope.row.id,scope.row.name,scope.row.yongjingData)" icon="el-icon-edit">修改佣金</el-button>
                    <el-button type="text" size="small" @click="lossOrder(scope.row)">丢单管理</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 



        <el-dialog :append-to-body="true"  title="收款配置" :visible.sync="collectionConfigVisible" width="600px" :close-on-click-modal="false">

            <el-form label-width="120px" class="demo-ruleForm">
                <el-form-item label="收款方式：" >
                    <el-radio-group v-model="typeKey">
                        <el-radio label="wxCollectConfig">微信收款</el-radio>
                        <el-radio label="lsCollectConfig">乐刷收款</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>

            <!-- 微信收款配置 -->
            <el-form :model="collectionConfigFormdata" :rules="collectionConfigRules" ref="collectionConfigForm" label-width="120px" class="demo-ruleForm" v-show="typeKey == 'wxCollectConfig'">
                <el-form-item label="wxAppId：" prop="wxAppId">
                    <el-input v-model="collectionConfigFormdata.wxAppId"></el-input>
                </el-form-item>
                <el-form-item label="wxMchId：" prop="wxMchId">
                    <el-input v-model="collectionConfigFormdata.wxMchId"></el-input>
                </el-form-item>
                <el-form-item label="wxKeySign：" prop="wxKeySign">
                    <el-input v-model="collectionConfigFormdata.wxKeySign"></el-input>
                </el-form-item>
                <el-form-item label="wxAppSecret：" prop="wxAppSecret">
                    <el-input v-model="collectionConfigFormdata.wxAppSecret"></el-input>
                </el-form-item>
                <el-form-item label="证书文件："  v-show="collectionConfigFormdata.collectPkcsUrl != null">
                    <a :href="urlPrefix + collectionConfigFormdata.collectPkcsUrl" target="_blank">{{collectionConfigFormdata.collectPkcsUrl}}</a>
                </el-form-item>
                <el-form-item label="选取证书文件：" >
                    <div class="toChooseFileBtn">选 择</div>
                    <input multiple type="file" ref="file" id="customerAccount-uploadFile" class="uploadFile" @change="chooseFile($event)">
                    <p>
                        <span v-show="collectPkcsFileName==''" style="color: #F56C6C;">未选择文件</span>
                        <span v-show="collectPkcsFileName!=''">已选择文件 {{collectPkcsFileName}}</span>
                    </p>
                 </el-form-item>
                 <el-form-item label="状态：" >
                    <el-radio-group v-model="collectionConfigFormdata.enable">
                        <el-radio label="1">启用</el-radio>
                        <el-radio label="0">禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>

            <!-- 乐刷收款配置 -->
            <el-form :model="lsCollectConfigFormdata" :rules="lsCollectConfigRules" ref="lsCollectConfigForm" label-width="120px" class="demo-ruleForm" v-show="typeKey == 'lsCollectConfig'">
                <el-form-item label="公众号ID：" prop="collectAppid">
                    <el-input v-model="lsCollectConfigFormdata.collectAppid"></el-input>
                </el-form-item>
                <el-form-item label="商户ID：" >
                    <el-input v-model="lsCollectConfigFormdata.typeValue.merchantId"></el-input>
                </el-form-item>
                <el-form-item label="交易密钥：" >
                    <el-input v-model="lsCollectConfigFormdata.typeValue.tradeKey"></el-input>
                </el-form-item>
                <el-form-item label="通知密钥：" >
                    <el-input v-model="lsCollectConfigFormdata.typeValue.notifyKey"></el-input>
                </el-form-item>
                <el-form-item label="回调地址：" >
                    <el-input v-model="lsCollectConfigFormdata.typeValue.basePayNotify"></el-input>
                </el-form-item>
                <el-form-item label="状态：" >
                    <el-radio-group v-model="lsCollectConfigFormdata.enable">
                        <el-radio label="1">启用</el-radio>
                        <el-radio label="0">禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
                
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelToSetCollectionConfig()">取 消</el-button>
                <el-button type="primary" @click="collectionConfigHandle()">保 存</el-button>
            </span>            
        </el-dialog>
        
           <el-dialog :append-to-body="true"  title="佣金记录" :visible.sync="importFailVisible" width="1000px" :close-on-click-modal="false">
                <el-form :inline="true" ref="searchForm" :model="searchForm" class="forTbFilter" @submit.native.prevent>
              <el-form-item label="下单时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <br>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getImportFailRecordListHandles"><i class="fa fa-search"></i> 查询</el-button>
                <el-button type="success" @click="exportOrderInfoHandle">导出Excel</el-button>
            </el-form-item>
        </el-form>
               <p style="color:red">此记录只包含套餐的佣金收入，不包含购卡佣金，退款等记录</p>
            <el-table :data="tbpg_fail.tableData" border height="421">
                 <el-table-column prop="iccid" label="ICCID" width="200px"></el-table-column>
                <el-table-column prop="orderNo" label="订单号" width="200px"></el-table-column>
                <el-table-column prop="pkgName" label="套餐名称" width="200px"></el-table-column>
                <el-table-column prop="commission" label="佣金"></el-table-column>
                 <el-table-column prop="createTime" label="时间"></el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="tbpg_fail.currentPage"
                :page-sizes="[10, 50, 100, 500]"
                :page-size="tbpg_fail.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tbpg_fail.total">
            </el-pagination>
        </el-dialog>



         <el-dialog :append-to-body="true"  title="修改佣金" :visible.sync="chgBalanceVisible" width="600px" @close="hideChangeBalanceDialog()" :close-on-click-modal="false">
            <el-form ref="changeBalanceForm" :model="changeBalanceForm"  label-width="120px">
                <el-form-item label="代理商名称：" >
                    <label >{{changeBalanceForm.name}}</label>
                </el-form-item>
                <el-form-item label="剩余佣金：" >
                    <label >{{changeBalanceForm.yongjingData}}</label>
                </el-form-item>
              
                <el-form-item label="变动类型:" >
                    <el-radio v-model="changeBalanceForm.updateType" label="0">扣减</el-radio>
                    <el-radio v-model="changeBalanceForm.updateType" label="1">增加</el-radio>
                </el-form-item>

                <el-form-item label="金额：" prop="subRmb">
                    <el-input-number v-model="changeBalanceForm.subRmb"
                    :precision="2" :step="1" :min="0">
                  </el-input-number>
                </el-form-item>
                <el-form-item label="备注：" prop="remark">
                    <el-input  type="textarea" v-model="changeBalanceForm.remark" placeholder="请输入内容" rows="3" maxlength="50" show-word-limit clearable></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="hideChangeBalanceDialog()">取 消</el-button>
                <el-button type="primary" @click="doChangeBalance()">确 定</el-button>
            </div> 
        </el-dialog> 



         <el-dialog :append-to-body="true" class="formDialog"  title="丢单配置" :visible.sync="lossFlg" width="600px" @close="cancel12" :close-on-click-modal="false">
            <el-form ref="lossData" :model="lossData" label-width="120px">  
                  
                 <el-form-item label="丢单倍数:" prop="lossOrder" >
                    <el-col :span="22">
                        <el-input v-model.trim="lossData.lossOrder"  placeholder="填5，则每5个订单 丢一笔订单不发佣金。填10 则每10笔丢1单" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel12">取 消</el-button>
                <el-button type="primary" @click="sureUpdata">确 定</el-button>
            </div>            
        </el-dialog>



    </div>
</template>

<script>
import {subAuth} from '@/api/system.js'
import {mapGetters } from "vuex";
import {getAccountListPage, changeCashbackState, collectionConfig, selectCollectionConfig, selectLsCollectionConfig, addLsCollectionConfig,getImportFailRecordList
 ,exportOrderInfo} from '@/api/customers.js'
import common from '@/utils/common.js'
import { mapActions } from "vuex";
export default {
    data(){
        return {
            searchForm: {
                name: '',
                sysUserAccountName: '',
                accountState: '',
                id:'',
                time:''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },

            //收款配置
            urlPrefix: process.env.VUE_APP_IMG_URL+'/',
            collectPkcsFileName:'',
            collectionConfigVisible: false,
            collectionConfigFormdata:{
                agentId: null, 
                wxAppId: null,
                wxMchId: null,
                wxKeySign: null,
                wxAppSecret: null,
                p12: null,
                collectPkcsUrl: null,
                enable: '1',
            },
            collectionConfigRules: {
                wxAppId: [
                    { required: true, message: '请输入wxAppId', trigger: 'blur' },
                ],
                wxMchId: [
                    { required: true, message: '请输入wxMchId', trigger: 'blur' },
                ],
                wxKeySign: [
                    { required: true, message: '请输入wxKeySign', trigger: 'blur' },
                ],
                wxAppSecret: [
                    { required: true, message: '请输入wxAppSecret', trigger: 'blur' },
                ],
            },
              tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0                
            },
            agentRemark:'',

            typeKey: 'wxCollectConfig',
            //乐刷收款配置
            lsCollectConfigFormdata:{
                collectAppid: null,
                clientId: null,
                typeKey: 'lsCollectConfig',
                typeValue: {
                    merchantId: null,
                    tradeKey: null,
                    notifyKey: null,
                    basePayNotify:null,
                },
                enable: '1',
            },


            lsCollectConfigRules: {
                collectAppid: [
                    { required: true, message: '请输入appId', trigger: 'blur' },
                ],
            },
            importFailVisible:false,
              changeBalanceForm:{
                id:'',
                updateType:'0',
                remark:'',
                subRmb:'',
                name:'',
                yongjingData:''
            },
            chgBalanceVisible:false,

             lossData:{
            id:'',
            lossOrder:''
        },
        lossFlg:false


        }
    },
    methods: {
        ...mapActions("menu", { setNickName: "setNickName", setBtns: "setBtns" }),
        loginAccount(accountName) {
            var data = {
                accountName: accountName,
                isAdmin: accountName
            }
            common.sysRequest("sysUser/checkout/login", data, 'post').then(res => {
                if (res.data.code == 200 || res.data.code == 401) {
                    localStorage.setItem('token', res.data.data.token);
                    localStorage.setItem('id', res.data.data.id);
                    localStorage.setItem('agentId', res.data.data.agentId);
                    this.$store.commit('menu/setToken', res.data.data.token);
                    this.$store.commit('menu/setId', res.data.data.id);
                    var nickName = res.data.data.nickName;
                    this.setNickName(nickName);
                    this.setBtns(res.data.data.actionCodes);
                    //this.$router.push('AdminHome');
                    window.location.reload();
                } else {
                    this.$message.error(res.data.message);
                }

            })

        },


         cancel12(){
           this.lossFlg=false; 
        },
        lossOrder(row){
            this.lossData.id=row.id;
            this.lossData.lossOrder=row.lossOrder;
            this.lossFlg=true;
        },
        sureUpdata(){
             common.sysRequest("agent/update/loss", this.lossData, "post").then((res) => {
          if (res.data.code == 200) {
            this.getAccountListPageHandle();
            this.lossFlg=false;
            this.$message.success(res.data.message);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));


        },


         hideChangeBalanceDialog(){
            for (let key in  this.changeBalanceForm) {
                this.changeBalanceForm[key] = '';
            }
            this.changeBalanceForm.updateType = '0';
            this.chgBalanceVisible = false;
        },
         showChangeBalanceDialog(id,name,yongjingData){
            this.changeBalanceForm.id=id;
            this.changeBalanceForm.name=name;
            this.changeBalanceForm.yongjingData=yongjingData;
            this.chgBalanceVisible = true;
        },
        doChangeBalance(){
                  common.sysRequest("agent/update/yongjing",this.changeBalanceForm, 'post').then(res => {
                 if(res.data.code == 200){
                    this.$message.success(res.data.message);
                    this.getAccountListPageHandle();
                     this.chgBalanceVisible = false;
                 }else{
                     this.$message.error(res.data.message);
                 }

            })    
        },
         authCount(row){
            var data = {
                agentId: row.id
            }
            subAuth(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success('认证次数-1！');
                     this.getAccountListPageHandle();   
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
          exportOrderInfoHandle(){
            common.deleteSpaceKey(this.searchForm); 
            this.searchForm.id=this.currentId_fail;
            this.$confirm('确定导出吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                exportOrderInfo(this.searchForm).then(res =>{
                    if(res.data.code == 200){
                        this.$message.success('数据导出中,请稍候去任务中心下载');
                    }else{
                        this.$message.error(res.data.msg);
                    }
                }).catch(err=>console.error(err));
            }).catch(() => {

            });
        },
         getImportFailRecordListHandle(id, $event){
            this.importFailVisible = true;
            this.currentId_fail = id;
            this.searchForm.id=id;
            var searchForm = {
                id: this.currentId_fail
            }
            common.resetCurrentPage(this, $event, 'tbpg_fail');
            var data = common.getRequestParams(this, 'tbpg_fail', searchForm);
            getImportFailRecordList(data).then(res => {
                common.listCallback(this, res, 'tbpg_fail');
            })
        },
        getImportFailRecordListHandles( $event){
            this.importFailVisible = true;
            this.searchForm.id=this.currentId_fail;
            common.resetCurrentPage(this, $event, 'tbpg_fail');
            var data = common.getRequestParams(this, 'tbpg_fail', this.searchForm);
            getImportFailRecordList(data).then(res => {
                common.listCallback(this, res, 'tbpg_fail');
            })
        },
     
        showbtnText(state){
            if(state == 0){
                return '启用秒返'
            }else if(state == 1){
                return '禁用秒返'
            }
        },
        getAccountListPageHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            getAccountListPage(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
            
        },
        changeCashbackStateHandle(id){
            changeCashbackState({id}).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message)
                    this.getAccountListPageHandle();                    
                }else{
                    this.$message.error(res.data.message)
                }
            })
        },
        //显示收款配置对话框
        showCollectionConfigVisible(agentId){
            this.collectionConfigFormdata.agentId = agentId;
            let f = new FormData();
            f.append('agentId', agentId);
            selectCollectionConfig(f).then(res => {
                if(res.data.code == 200){
                    if(res.data.data){
                        for(let key in res.data.data){
                            this.collectionConfigFormdata[key] = res.data.data[key];
                        }
                        this.collectionConfigFormdata.enable = this.collectionConfigFormdata.enable+'';
                    }
                    this.collectionConfigVisible = true;               
                }else{
                    this.collectionConfigVisible = true;
                }
            });

            // 乐刷配置
            this.lsCollectConfigFormdata.clientId = agentId;

            selectLsCollectionConfig({typeKey:'lsCollectConfig',clientId: agentId}).then(res => {
                if(res.data.code == 200){
                    if(res.data.data){
                        for(let key in this.lsCollectConfigFormdata){
                            this.lsCollectConfigFormdata[key] = res.data.data[key];
                        }
                        this.lsCollectConfigFormdata.enable = this.lsCollectConfigFormdata.enable+'';
                        if(res.data.data.typeValue){
                            this.lsCollectConfigFormdata.typeValue = JSON.parse(res.data.data.typeValue);
                        }
                        
                    }
                    this.collectionConfigVisible = true;               
                }else{
                    this.collectionConfigVisible = true;
                }
            });

        },
        
        //收款配置
        collectionConfigHandle(){
            // 微信收款配置
            if(this.typeKey == 'wxCollectConfig'){
                this.$refs["collectionConfigForm"].validate((valid) => {
                    if (valid) {
                        this.$confirm("确定保存新修改的数据吗？", "提示" ,{          
                            confirmButtonText: '确定',
                            cancelButtonText: '取消'
                        }).then(() => {
                            let formdata = new FormData();
                            Object.keys(this.collectionConfigFormdata).forEach((key) => {
                                formdata.append(key, this.collectionConfigFormdata[key]);
                            });

                            collectionConfig(formdata).then(res => {
                                if(res.data.code == 200){
                                    this.$message.success(res.data.message)
                                    this.getAccountListPageHandle(); 
                                    this.cancelToSetCollectionConfig();                   
                                }else{
                                    this.$message.error(res.data.message)
                                }
                            }).catch(err=>console.error(err));
                        }).catch(() => {
                            
                        });
                    }
                });
            }

            // 乐刷收款配置
            else if(this.typeKey == 'lsCollectConfig'){

                for(let key in this.lsCollectConfigFormdata.typeValue){
                    if(this.lsCollectConfigFormdata.typeValue[key] == null ||
                        this.lsCollectConfigFormdata.typeValue[key] == ''){
                        this.$message.error('请将信息填写完整');
                        return;
                    }
                }

                //校验回调地址
                if(this.lsCollectConfigFormdata.typeValue.basePayNotify.indexOf("http://")!=0){
                    this.$message.error('回调地址请以“ http:// ”开头');
                    return;
                }


                this.$refs["lsCollectConfigForm"].validate((valid) => {
                    if (valid) {
                        this.$confirm("确定保存新修改的数据吗？", "提示" ,{          
                            confirmButtonText: '确定',
                            cancelButtonText: '取消'
                        }).then(() => {
                            let d = this.lsCollectConfigFormdata;
                            d.typeValue = JSON.stringify(this.lsCollectConfigFormdata.typeValue);
                            addLsCollectionConfig(d).then(res => {
                                if(res.data.code == 200){
                                    this.$message.success(res.data.message)
                                    this.getAccountListPageHandle(); 
                                    this.cancelToSetCollectionConfig();                   
                                }else{
                                    this.$message.error(res.data.message)
                                }
                            }).catch(err=>console.error(err));
                        }).catch(() => {
                            
                        });
                    }
                });
            }
            

        },
        //取消收款配置
        cancelToSetCollectionConfig(){
            for(let key in this.collectionConfigFormdata){
                this.collectionConfigFormdata[key] = null;
            }
            document.getElementById('customerAccount-uploadFile').value = '';
            this.collectPkcsFileName = '';
            this.collectionConfigVisible = false;
        },
        //选择证书文件
        chooseFile(event) {
            let files = event.target.files;
            let filename = files[0].name          //只有一个文件
            if ( filename.lastIndexOf('.') <= 0 ) {
                return alert("Please add a valid image!")        //判断文件是否有效
            }
            let fileReader = new FileReader()                //内置方法new FileReader()   读取文件
            fileReader.readAsDataURL(files[0])
            this.collectionConfigFormdata.p12 = files[0];
            this.collectPkcsFileName = filename;
        },

        handleSizeChange(val){
             if(this.importFailVisible){
                this.tbpg_fail.pageSize = val;
                this.getImportFailRecordListHandle(this.currentId_fail);
            }else{
                this.tbpg.pageSize = val;
                this.getAccountListPageHandle();
            }
           
        },
        handleCurrentChange(val){
            if(this.importFailVisible){
                this.tbpg_fail.currentPage = val;
                this.getImportFailRecordListHandle(this.currentId_fail);
            }else{
                this.tbpg.currentPage = val;
                this.getAccountListPageHandle();
            }
   
        }  
    },
    computed:{
        ...mapGetters("menu", {
            hasAuthority: "hasAuthority" 
        }),

        fromPageIccid: function(){
            return this.$store.state.menu.iccidToAccount;
        },
    },
    created () {
        this.getAccountListPageHandle();
              common.sysRequest('agent/sum/agent/data', {}, 'post').then(res => {
                if(res.data.code == 200){
                    this.agentRemark='所有代理商未提佣金为：'+res.data.data.yongjingData+",所有代理商剩余预存金额为："+res.data.data.yuchongzhi;
                }
            })
    }  
}
</script>

<style lang="less" scoped>

#customerAccount{
    .uploadFile{
        opacity: 0;
        height: 32px;
    }

    .toChooseFileBtn{
        position: absolute;
        left: 0;
        top: 0;
        background: none;
        border: 1px solid #DCDFE6;
        color: #606266;
        width: 80px;
        height: 32px;
        border-radius: 5px;
        text-align: center;
        font-size: 12px;
    }
}

</style>

